import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationStoringIncompleteDto extends IGetNotification {
    reservationId: Guid
    reservationNumber?: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
    assets: Guid[]
    manualPositions: string[]
}

export default class NotificationStoringIncomplete extends Notification {
    reservationId: Guid
    reservationNumber?: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
    assetIds: Guid[]
    assets: NotificationAsset[]
    manualPositions: string[]

    constructor(dto: IGetNotificationStoringIncompleteDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.shippingOrderId = dto.shippingOrderId
        this.shippingOrderNumber = dto.shippingOrderNumber
        this.assetIds = dto.assets
        this.assets = dto.assets.map(assetId => {
            return new NotificationAsset({
                assetId,
            })
        })
        this.manualPositions = dto.manualPositions
    }
}
